import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-required-message',
    templateUrl: './required-message.component.html',
    standalone: true,
    imports: [
        CommonModule,
    ],
})
export class RequiredMessageComponent implements OnInit
{
    @Input() message = 'This field is required.';

    constructor() {
    }

    ngOnInit(): void {
    }

}
